<template>
  <div class="header" :class="{ active: isHeaderActive, 'main-header': isMain }">
    <div class="content">
      <div class="logo">
        <router-link to="/"></router-link>
      </div>
      <div class="nav">
        <ul>
          <li>
            <router-link
            
              :to="isLogin ? '/company-credit' : '/credit-intro'"
            >자사신용관리</router-link>
          </li>
          <li>
            <router-link
              :to="isLogin ? '/vendor-credit' : '/credit-intro'"
            >{{isAssn ? "회원사" : "거래처"}} 신용관리</router-link>
          </li>
          <li class="has-sub-menu">
            <button type="button" class="nav-menu-button">주요서비스</button>
            <ul class="sub-menu">
              <li><router-link to="/lifecycle-service" @click="closeSubMenu">기업 생애주기별 서비스</router-link></li>
              <li><router-link to="/service" @click="closeSubMenu">유용한 서비스</router-link></li>
            </ul>
          </li>
          <li>
            <router-link to="/cs?pageFlag=1">고객지원</router-link>
          </li>
        </ul>
      </div>
      <div class="btn-box">
        <template v-if="isLogin">
          <router-link class="join-btn" to="/mypage">마이페이지</router-link>
          <a class="login-btn" @click="logout">로그아웃</a>
        </template>
        <template v-else>
          <router-link class="join-btn" to="/sign-up">회원가입</router-link>
          <router-link class="login-btn" to="/login">로그인</router-link>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    isHeaderActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isMain: true,
    };
  },
  computed: {
    ...mapGetters("userStore", ["isLogin", "isAssn", "getGrade"]),
  },
  created() {
    this.isMain = this.$route.name === "Main";
  },
  methods: {
    closeSubMenu(event) {
      event.currentTarget.blur();
    },
    async logout() {
      await this.$store.dispatch("userStore/LOGOUT");
      this.$router.push("/");
      //TODO alert?
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-box a {
  cursor: pointer;
}

.has-sub-menu {
  position: relative;
}

.nav-menu-button {
  padding: 0;
  border: 0;
  background: transparent;
  color: #000;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: color 0.2s;
}

.header.main-header .nav-menu-button {
  color: #fff;
}

.header.main-header.active .nav-menu-button {
  color: #000;
}

.has-sub-menu:hover .nav-menu-button,
.has-sub-menu:focus-within .nav-menu-button,
.header.main-header .has-sub-menu:hover .nav-menu-button,
.header.main-header .has-sub-menu:focus-within .nav-menu-button,
.header.main-header.active .has-sub-menu:hover .nav-menu-button,
.header.main-header.active .has-sub-menu:focus-within .nav-menu-button {
  color: #3f80ea;
}

.sub-menu {
  position: absolute;
  top: calc(100% + 32px);
  left: 50%;
  z-index: 100;
  display: flex !important;
  min-width: 220px;
  padding: 8px;
  gap: 0 !important;
  flex-direction: column;
  visibility: hidden;
  opacity: 0;
  transform: translate(-50%, 8px);
  border: 1px solid #e1e1e1;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.14);
  transition: opacity 0.18s, transform 0.18s, visibility 0.18s;
}

.sub-menu::before {
  position: absolute;
  right: 0;
  bottom: 100%;
  left: 0;
  height: 32px;
  content: "";
}

.has-sub-menu:hover .sub-menu,
.has-sub-menu:focus-within .sub-menu {
  visibility: visible;
  opacity: 1;
  transform: translate(-50%, 0);
}

.sub-menu li,
.sub-menu a {
  width: 100%;
}

.sub-menu a {
  display: block;
  box-sizing: border-box;
  padding: 11px 14px;
  border-radius: 8px;
  color: #333 !important;
  font-size: 15px !important;
  font-weight: 500 !important;
  text-align: center;
  white-space: nowrap;
}

.sub-menu a:hover,
.sub-menu a.router-link-active {
  background: #f0f6ff;
  color: #3f80ea !important;
}
</style>
